<template>

<div class="social">

	<a v-if="settings.header_social_twitter_enabled" :href="settings.header_social_twitter_url" target="_blank" class="social-item" v-tooltip="'Like us on Facebook'"><app-icon name="facebook" /></a>
	<a v-if="settings.header_social_facebook_enabled" :href="settings.header_social_facebook_url" target="_blank" class="social-item" v-tooltip="'Follow us on Twitter'"><app-icon name="twitter" /></a>
	<a v-if="settings.header_social_instagram_enabled" :href="settings.header_social_instagram_url" target="_blank" class="social-item" v-tooltip="'Join us on Instagram'"><app-icon name="instagram" /></a>
	<a v-if="settings.header_social_linkedin_enabled" :href="settings.header_social_linkedin_url" target="_blank" class="social-item" v-tooltip="'Connect with us on Linkedin'"><app-icon name="linkedin" /></a>

</div>

</template>

<script>

export default {
	
}

</script>

<style scoped>

.social {
	display: flex;
	flex-direction: row;
	padding: 12px 0px;
}

.social-item {
	width: 40px;
	height: 40px;
	border: 2px solid var(--color-blue-light);
	color: var(--color-blue-light);
	border-radius: 50%;
	margin-right: 4px;
	font-size: 24px;
	line-height: 36px;
	text-align: center;
	transition: all 100ms linear;
}

.is-desktop .social-item:hover {
	background-color: var(--color-blue-light);
	color: #fff;
}

</style>